module.exports = __webpack_public_path__ + "img/Gerätewagen_Gefahrgut.9e11ca80.svg";